module.exports = __webpack_public_path__ + "img/NEOS.253923a7.svg";